import { render } from "./IconLowLatencyMode.vue?vue&type=template&id=c3b37388"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconLowLatencyMode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3b37388"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3b37388', __exports__)) {
    api.reload('c3b37388', __exports__)
  }
  
  module.hot.accept("./IconLowLatencyMode.vue?vue&type=template&id=c3b37388", () => {
    api.rerender('c3b37388', render)
  })

}


export default __exports__